import { render, staticRenderFns } from "./SpeedsFeeds.vue?vue&type=template&id=569eadcc&scoped=true&lang=pug&"
import script from "./SpeedsFeeds.vue?vue&type=script&lang=js&"
export * from "./SpeedsFeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569eadcc",
  null
  
)

export default component.exports